import { render, staticRenderFns } from "./Youtube.vue?vue&type=template&id=dfab9a1e&scoped=true&"
import script from "./Youtube.vue?vue&type=script&lang=js&"
export * from "./Youtube.vue?vue&type=script&lang=js&"
import style0 from "./Youtube.vue?vue&type=style&index=0&id=dfab9a1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfab9a1e",
  null
  
)

export default component.exports